// removed by extract-text-webpack-plugin
module.exports = {"singleBetGameCardContainer":"_2V25_YfOHH_yHCItVWNakN","marbleFont":"_7xbtXT01kZGHB8DvhVdXV","buttonCustomStyle":"_2QzflaVC00UFBoX_4FycEH","last":"_3-y1QTugV-hA2MwpbRxliZ","racerNumber":"_1GNi9OOdxC1y5YTncLfnoU","racerName":"Drm-BVzmNwf92WcM-fO2n","racerIcon":"_3vTb-K8TGewxkmzpgFOKgw","racerIconImage":"nV-tmWvQO6jIkceZbUwfq","silkNumber":"_1_n9cj4YXW0j7txbIjP4EQ"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/racing/css/singleBetGameCard.css
// module id = 668
// module chunks = 0